export const DEV_AUTH_TOKEN = 'polatkan-local-development';

const loopbackHosts = new Set(['localhost', '127.0.0.1', '[::1]']);

/** Never send the development marker to a production API or from a deployed UI. */
export function getDevAuthToken(apiUrl: string): string | null {
  if (
    !import.meta.env.DEV ||
    import.meta.env.VITE_DEV_AUTH_BYPASS !== 'true' ||
    typeof window === 'undefined' ||
    !loopbackHosts.has(window.location.hostname)
  )
    return null;

  try {
    const url = new URL(apiUrl);
    return url.protocol === 'http:' && loopbackHosts.has(url.hostname) ? DEV_AUTH_TOKEN : null;
  } catch {
    return null;
  }
}
